import logger from '../utils/logger';
import { apiGet, apiPost } from './api';

export const notificationService = {
    // Get all notifications
    getNotifications: async () => {
        try {
            const response = await apiGet('notifications');
            if (response.success) {
                return response.data || [];
            }
            logger.error('Failed to fetch notifications:', response.message);
            return [];
        } catch (error) {
            logger.error('Error fetching notifications:', error);
            return [];
        }
    },

    // Mark a notification as read
    markAsRead: async (notificationId) => {
        try {
            const response = await apiPost(`notifications/${notificationId}/read`);
            return response.success;
        } catch (error) {
            logger.error('Error marking notification as read:', error);
            return false;
        }
    },

    // Mark all notifications as read
    markAllAsRead: async () => {
        try {
            const response = await apiPost('notifications/read-all');
            return response.success;
        } catch (error) {
            logger.error('Error marking all notifications as read:', error);
            return false;
        }
    }
};

export default notificationService; 